import React from "react";
import "./Help.css";
import TutorialStep from "../Tutorial/TutorialStep";
import windowsTray from "../../assets/images/tutorial/windows/windows1r.png";
import windows2r from "../../assets/images/tutorial/windows/windows2r.png";
import windowsOpen from "../../assets/images/tutorial/windows/windows3r.png";
import macOs1 from "../../assets/images/tutorial/macOS/macOS1r.png";
import macOs2 from "../../assets/images/tutorial/macOS/macOS2r.png";
import iOS1 from "../../assets/images/tutorial/iOS/iOS1r.png";
import iOS2 from "../../assets/images/tutorial/iOS/iOS2r.png";
import iOS3 from "../../assets/images/tutorial/iOS/iOS3r.PNG";
import iOSManual1 from "../../assets/images/tutorial/iOS/iOS1r.png";
import iOSManual2 from "../../assets/images/tutorial/iOS/iOS2-2r.png";
import iOSManual3 from "../../assets/images/tutorial/iOS/iOS2-3r.png";

const Help = () => {
  const tutorialSteps = [
    {
      title: "Download the iOS App",
              description: "Start by downloading the AirMouse app from the iOS App Store. Search for 'AirMouse' and install the app on your device.",
              imageDescription: "Screenshot of AirMouse in the iOS App Store with download button highlighted",
      annotations: [
        { x: "50%", y: "30%", text: "Download Button" }
      ]
    },
    {
      title: "Install the Desktop App",
      subSteps: [
        {
          title: "Windows Installation",
          description: "Download the Windows version and run the installer. If Windows SmartScreen shows a warning, this is normal for new applications. Click 'More info' and then 'Run anyway' to proceed. See our FAQ for more details about Windows SmartScreen warnings.",
          imageDescription: "Windows installation process with SmartScreen warning handling"
        },
        {
          title: "macOS Installation",
          description: "Download the macOS version and open the .dmg file. Drag the app to your Applications folder. You'll need to grant Accessibility permissions during setup. See our FAQ for detailed information about required macOS permissions.",
          imageDescription: "macOS installation process with permission setup"
        }
      ]
    },
    {
      title: "Connect Your Devices",
      description: "You can connect your iOS device to your computer in two ways:",
      subSteps: [
        {
          title: "Using Device Finder",
          description: "When the desktop app is running, it automatically broadcasts its presence. Open the AirMouse app on your iOS device and tap 'Find Devices'. Your computer should appear in the list.",
          imageDescription: "Screenshot of the iOS app showing the device finder screen with available computers listed",
          annotations: [
            { x: "50%", y: "30%", text: "Find Devices Button" },
            { x: "50%", y: "60%", text: "Available Computers List" }
          ],
          additionalImages: [
            {
              image: iOS1,
              arrow: "→",
              middleImage: iOS2,
              arrow2: "→",
              finalImage: iOS3
            }
          ]
        },
        {
          title: "Manual IP Connection",
          description: "Alternatively, you can connect manually by entering your computer's IP address. In the iOS app, tap 'Connect Manually' and enter the IP address you found in the previous step.",
          imageDescription: "Screenshot of the iOS app showing the manual connection screen with IP address input field",
          annotations: [
            { x: "50%", y: "40%", text: "IP Address Input" },
            { x: "50%", y: "60%", text: "Connect Button" }
          ],
          additionalImages: [
            {
              image: iOSManual1,
              arrow: "→",
              middleImage: iOSManual2,
              arrow2: "→",
              finalImage: iOSManual3,
              useIPhoneFrame: true
            }
          ]
        }
      ]
    },
    {
      title: "Find Your Computer's IP Address",
      description: "You'll need your computer's IP address to connect. Here's how to find it:",
      subSteps: [
        {
          title: "Windows",
          description: "Right-click the AirMouse icon in the system tray and select 'Open'. The IP address will be displayed in the window.",
          imageDescription: "Screenshot showing the AirMouse system tray icon and the window displaying the IP address",
          annotations: [
            { x: "20%", y: "50%", text: "System Tray Icon" },
            { x: "60%", y: "40%", text: "IP Address Display" }
          ],
          additionalImages: [
            {
              image: windowsTray,
              arrow: "→",
              middleImage: windows2r,
              arrow2: "→",
              finalImage: windowsOpen
            }
          ]
        },
        {
          title: "macOS",
          description: "Click the AirMouse icon in the menu bar. The IP address will be displayed in the dropdown menu.",
          imageDescription: "Screenshot showing the AirMouse menu bar icon and dropdown with IP address",
          annotations: [
            { x: "20%", y: "50%", text: "Menu Bar Icon" },
            { x: "60%", y: "40%", text: "IP Address Display" }
          ],
          additionalImages: [
            {
              image: macOs1,
              arrow: "→",
              finalImage: macOs2
            }
          ]
        }
      ]
    }
  ];

  return (
    <div className="help-container">
      <header>Getting Started with AirMouse</header>
      <p className="help-intro">Follow these steps to set up AirMouse and connect your iOS device to your computer. We'll guide you through the installation and connection process with detailed instructions and visual aids.</p>
      
      <div className="tutorial-steps">
        {tutorialSteps.map((step, index) => (
          <TutorialStep
            key={index}
            title={step.title}
            description={step.description}
            image={step.image}
            imageDescription={step.imageDescription}
            videos={step.videos}
            annotations={step.annotations}
            subSteps={step.subSteps}
          />
        ))}
      </div>
    </div>
  );
};

export default Help;
